var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnsweredQuestionaire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-664.000000, -304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_answered_questionare",
    transform: "translate(664.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "questionnaire",
    transform: "translate(3.000000, 5.000000)",
    fill: "#1A73E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6914063,8.63506797e-16 C10.3581563,8.63506797e-16 8.39675391,1.4541 7.70385938,3.4494 C8.61510938,3.8042 9.41371875,4.36023333 10.0546875,5.05096667 L10.0546875,4.5 L11.109375,4.5 L11.109375,5.5 L10.4320898,5.5 C11.1848906,6.4864 11.6367188,7.69166667 11.6367188,9 C11.6367188,9.29896667 11.6058867,9.59056667 11.5611328,9.87793333 C11.926125,9.95396667 12.3026484,10 12.6914063,10 L18,10 L17.1899297,7.66456667 C17.7208945,6.86816667 18,5.95263333 18,5 C18,2.24316667 15.5990039,8.63506797e-16 12.6914063,8.63506797e-16 Z M13.21875,5.5 L12.1640625,5.5 L12.1640625,4.5 L13.21875,4.5 L13.21875,5.5 Z M15.328125,5.5 L14.2734375,5.5 L14.2734375,4.5 L15.328125,4.5 L15.328125,5.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30859375,4 C2.40099609,4 0,6.24316667 0,9 C0,9.95263333 0.279105469,10.8681667 0.810070313,11.6645667 L0,14 L5.30859375,14 C8.21619141,14 10.5820312,11.7568333 10.5820312,9 C10.5820312,6.24316667 8.21619141,4 5.30859375,4 Z M5.8359375,12 L4.78125,12 L4.78125,11 L5.8359375,11 L5.8359375,12 Z M6.45444141,8.53466667 C6.0553125,8.93116667 5.8359375,9.45263333 5.8359375,10 L4.78125,10 C4.78125,9.19433333 5.10416016,8.42773333 5.69070703,7.84473333 C5.78443359,7.75146667 5.8359375,7.6289 5.8359375,7.5 C5.8359375,7.22413333 5.59954688,7 5.30859375,7 C5.01764062,7 4.78125,7.22413333 4.78125,7.5 L3.7265625,7.5 C3.7265625,6.67286667 4.43622656,6 5.30859375,6 C6.18096094,6 6.890625,6.67286667 6.890625,7.5 C6.890625,7.88673333 6.73562109,8.2539 6.45444141,8.53466667 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsweredQuestionaire);
export default __webpack_public_path__ + "static/media/answered-questionaire.431394443d2cc519d6d0d7db0ce9ac7f.svg";
export { ForwardRef as ReactComponent };